import { useMemo } from 'react';
import { CSSObject } from '@mantine/core';
import { ModalBaseCloseButtonStylesNames } from '@mantine/core/lib/ModalBase/ModalBaseCloseButton/ModalBaseCloseButton';
import { ModalBaseOverlayStylesNames } from '@mantine/core/lib/ModalBase/ModalBaseOverlay/ModalBaseOverlay';
import { ModalBaseContentStylesNames } from '@mantine/core/lib/ModalBase/ModalBaseContent/ModalBaseContent';
import { ModalBaseHeaderStylesNames } from '@mantine/core/lib/ModalBase/ModalBaseHeader/ModalBaseHeader';
import { ModalBaseTitleStylesNames } from '@mantine/core/lib/ModalBase/ModalBaseTitle/ModalBaseTitle';
import { ModalBaseBodyStylesNames } from '@mantine/core/lib/ModalBase/ModalBaseBody/ModalBaseBody';

type ModalStylesNames = ModalBaseCloseButtonStylesNames | ModalBaseOverlayStylesNames
	| ModalBaseContentStylesNames | ModalBaseHeaderStylesNames | ModalBaseTitleStylesNames
	| ModalBaseBodyStylesNames;

export type ModalStyles = {
	[key in ModalStylesNames]?: CSSObject;
};

type UseStackeableModalProps = {
	stackOrder?: number;
	defaultStyles?: ModalStyles;
};

const useStackeableModal = ( { stackOrder = 1, defaultStyles = {} }: UseStackeableModalProps ) => {
	const submodalsStackOrder = stackOrder + 1;
	const submodalOpacity = stackOrder > 1 ? 0.3 * ( 1 / stackOrder ) : 0;

	const modalStyles = useMemo( () => ( {
		...defaultStyles,
		overlay: {
			...( defaultStyles?.overlay || {} ),
			...( stackOrder > 1 ? { backgroundColor: `rgba(0, 0, 0, ${submodalOpacity})` } : {} ),
			zIndex: 200 + stackOrder * 10
		},
		inner: {
			...( defaultStyles?.inner || {} ),
			zIndex: 201 + stackOrder * 10
		}
	} ), [ stackOrder ] );

	return { submodalsStackOrder, modalStyles };
};

export default useStackeableModal;
